import React from 'react';

export function FileExported({ color }: { color: 'blue' | 'gray' }) {
  const fill = color === 'blue' ? '#2563EB' : '#9CA3AF';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
      <path
        d="M15.0008 9.375C14.7008 9.375 14.4258 9.625 14.4258 9.95V12.175C14.4258 12.4 14.2508 12.575 14.0258 12.575H1.97578C1.75078 12.575 1.57578 12.4 1.57578 12.175V9.95C1.57578 9.65 1.32578 9.375 1.00078 9.375C0.675781 9.375 0.425781 9.625 0.425781 9.95V12.175C0.425781 13.025 1.10078 13.7 1.95078 13.7H14.0258C14.8758 13.7 15.5508 13.025 15.5508 12.175V9.95C15.5758 9.625 15.3008 9.375 15.0008 9.375Z"
        fill={fill}
      />
      <path
        d="M7.60131 9.9748C7.70131 10.0748 7.85131 10.1248 8.00131 10.1248C8.15131 10.1248 8.27631 10.0748 8.40131 9.9748L11.9763 6.4998C12.2013 6.2748 12.2013 5.9248 12.0013 5.6998C11.7763 5.4748 11.4263 5.4748 11.2013 5.6748L8.57631 8.2498V0.874805C8.57631 0.574805 8.32631 0.299805 8.00131 0.299805C7.70131 0.299805 7.42631 0.549805 7.42631 0.874805V8.2498L4.80131 5.6998C4.57631 5.4748 4.22631 5.4998 4.00131 5.6998C3.77631 5.9248 3.80131 6.2748 4.00131 6.4998L7.60131 9.9748Z"
        fill={fill}
      />
    </svg>
  );
}
